import { Box } from '@mui/material';
import { markets } from 'constants/markets';
import { useRouter } from 'next/router';
import { useState, ChangeEvent, SyntheticEvent } from 'react';
import useMarket from 'stores/useMarket';
import useSearch from 'stores/useSearch';
import AccountMenuButtons from './components/AccountMenuButtons';
import { PopupSearchResults } from '../PopupSearchResults';
import SearchField from '../../SearchField';
import { MobileWordpressMenu } from './components/MobileWordpressMenu';

type MobileMenuProps = {
    toggleDrawer: () => void;
};

export default function MobileMenu({ toggleDrawer }: MobileMenuProps) {
    const market = useMarket((state) => state.market);
    const router = useRouter();
    const { setSearchValue } = useSearch();
    const [searchFieldValue, setSearchFieldValue] = useState('');
    function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
        setSearchFieldValue(event.target.value);
    }

    function handleReroute<T extends SyntheticEvent>(event: T): void {
        event.preventDefault();
        router.push(
            `/catalogsearch/result/${searchFieldValue}`,
            `/catalogsearch/result/${searchFieldValue}`,
            { locale: markets[market].locale },
        );
    }

    function handleSearchFieldClear() {
        setSearchValue('');
        setSearchFieldValue('');
        toggleDrawer();
    }

    return (
        <>
            <SearchField
                handleInputChange={handleInputChange}
                handleSearchFieldClear={handleSearchFieldClear}
                handleOnClickSearch={(event) => {
                    handleReroute(event);
                    handleSearchFieldClear();
                }}
                searchFieldValue={searchFieldValue}
            />
            <Box>
                {searchFieldValue.length > 3 ? (
                    <PopupSearchResults
                        searchValue={searchFieldValue}
                        handleSearchFieldClear={handleSearchFieldClear}
                        handleShowSearchResults={(event) => {
                            handleReroute(event);
                            handleSearchFieldClear();
                        }}
                    />
                ) : (
                    <>
                        <AccountMenuButtons />
                        <MobileWordpressMenu />
                    </>
                )}
            </Box>
        </>
    );
}
